var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{key:_vm.cKey,staticClass:"prime-list lines-bottom"},_vm._l((_vm.tree),function(treenode){return _c('tree-control',{key:treenode.name,attrs:{"nodes":treenode.orgs,"hasChildren":treenode.countSubOrgs,"label":treenode.name,"id":treenode.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }